import React from 'react';
import take from 'ramda/src/take.js';
import cx from 'classnames';
import invoke from 'lodash.invoke';
import {t} from '../../util/i18n';

const moreBtnStyle = 'flex flex-col items-center justify-center h-full text-title leading-tight rounded bg-moon-grey link-2 t-bg-color t-duration-short hover:bg-blue hover:text-white';
const thumbnailStyle = 'block mb-4 link-hover';

const TRUNC_THRESHOLD = 4;
const ThumbnailList = ( {list, assetComponent, maxLength = 0, ...props} ) => {
    const remainingListCount = list.length - maxLength;
    const showMoreAction = maxLength > 0 && remainingListCount >= TRUNC_THRESHOLD;
    const takeSize = showMoreAction ? maxLength : list.length;
    const handleClick = e => invoke( props, 'onMoreClick', e );
    const AssetComponent = assetComponent;

    return (
        <nav className="gap-4 grid auto-rows-fr grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 justify-center items-center">
            {take( takeSize, list )
                .map( asset => <AssetComponent key={asset.id} {...asset}/> )}
            {showMoreAction &&
                <button
                    onClick={handleClick}
                    className={cx( thumbnailStyle, moreBtnStyle )}>
                    <span>{t(
                        'label.plusMoreWithCount',
                        '+ {{count}} more',
                        {count: list.length - maxLength}
                    )}</span>
                </button>
            }
        </nav>
    );
};

export default ThumbnailList;
